import React, { memo } from 'react';
import { Container } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import EventsList from 'components/common/EventsList';
import { GlobalStyles } from 'tss-react';

export interface IEventsScreenProps {
  top?: React.ReactNode;
  events: any[];
  isEventsFetching: boolean;
  onToggleFavoriteEvent: (id: number) => void;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    paddingTop: theme.spacing(4),
    minHeight: 'calc(100vh - 64px)',
    [theme.breakpoints.down('md')]: {
      overflowX: 'hidden',
      overflowY: 'hidden',
    },
  },
}));

const EventsScreen: React.FC<React.PropsWithChildren<IEventsScreenProps>> = (props) => {
  const { top, events, isEventsFetching, onToggleFavoriteEvent } = props;

  const { classes } = useStyles();
  return (
    <>
      <GlobalStyles
        styles={{
          body: {
            backgroundColor: 'white',
          },
        }}
      />
      <Container maxWidth="lg" className={classes.root}>
        <EventsList
          top={top}
          events={events}
          hasFilters
          isEventsFetching={isEventsFetching}
          onToggleFavoriteEvent={onToggleFavoriteEvent}
        />
      </Container>
    </>
  );
};

export default memo(EventsScreen);
